import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import { twMerge } from 'tailwind-merge';

function ToggleGroup({
  className,
  ...props
}: (ToggleGroupPrimitive.ToggleGroupSingleProps | ToggleGroupPrimitive.ToggleGroupMultipleProps) & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <ToggleGroupPrimitive.Root
      loop={false}
      {...props}
      className={twMerge(
        'flex h-[42px] items-center overflow-auto rounded-lg border border-neutral-300',
        'focus-within:border-blue-400 focus-within:ring-1 focus-within:ring-blue-400',
        className,
      )}
    />
  );
}

function ToggleGroupItem({ children, className, ...props }: ToggleGroupPrimitive.ToggleGroupItemProps) {
  return (
    <ToggleGroupPrimitive.Item
      type="button"
      {...props}
      className={twMerge(
        'flex h-full min-w-[36px] items-center justify-center bg-neutral-50 px-2 text-neutral-700 outline-none',
        'hover:bg-neutral-200',
        'focus:bg-neutral-200',
        'first:border-r first:border-neutral-200',
        'radix-state-on:bg-blue-400 radix-state-on:text-white',
        className,
      )}
    >
      {children}
    </ToggleGroupPrimitive.Item>
  );
}

ToggleGroup.Item = ToggleGroupItem;

export { ToggleGroup };
